var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VTextField',{attrs:{"label":_vm.label,"rules":_vm.rules,"type":_vm.show ? 'text' : 'password',"append-icon":_vm.show ? 'mdi-eye-off': 'mdi-eye',"outlined":"","dense":"","hideDetails":"auto","autocomplete":"new-password"},on:{"input":(value) => _vm.$emit('input', value),"click:append":function($event){_vm.show = !_vm.show}}})
}
var staticRenderFns = []

export { render, staticRenderFns }